var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _line, _line2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path9, _path10, _path11, _line3, _line4, _line5, _path12, _line6, _line7, _line8, _path13, _path14, _line9, _line10, _rect7, _rect8, _rect9, _path15, _rect10, _rect11, _rect12, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard1Frame15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 637,
    height: 353,
    viewBox: "0 0 637 353",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M341.317 218.143L341.805 132.198C341.731 131.005 342.498 128.796 346.149 129.513L517.885 129.513C519.651 129.14 523.849 129.692 526.514 134.884L570.427 195.314C571.78 197.179 575.302 200.909 578.573 200.909L635.578 200.909",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M296.09 218.367L296.579 132.341C296.666 131.146 295.924 128.935 292.261 129.652L120.388 129.652C118.625 129.279 114.417 129.832 111.692 135.03L67.0563 195.531C65.6816 197.398 62.1137 201.133 58.8399 201.133L1.78973 201.133",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M295.536 317.069L295.495 324.231C295.569 325.276 295.093 327.365 292.591 327.365L222.598 327.365C221.957 327.365 220.2 326.111 218.304 321.098C217.888 319.997 215.93 315.175 212.951 307.893M1.67185 221.948L21.7558 221.948M139.074 189.943L139.053 193.524L139.095 186.138M139.074 189.943L150.438 189.943M139.074 189.943L127.709 189.943M150.438 189.943L161.803 189.943C163.92 189.943 165.398 192.33 165.872 193.524C176.076 218.249 192.697 258.563 204.505 287.302M150.438 189.943L150.418 193.524L150.46 186.138M127.709 189.943L116.344 189.943C114.902 189.793 111.339 190.301 108.627 193.524L98.0934 205.945M127.709 189.943L127.688 193.524L127.73 186.138M98.0934 205.945L87.56 218.367C86.3506 219.561 83.5469 221.948 82.0076 221.948L61.9236 221.948M98.0934 205.945L108.556 205.945L87.6305 205.945M41.8397 221.948L41.813 226.648M41.8397 221.948L61.9236 221.948M41.8397 221.948L21.7558 221.948M61.9236 221.948L61.897 226.648M21.7558 221.948L21.7291 226.648M212.951 307.893L224.633 307.893M212.951 307.893C211.709 304.858 210.291 301.396 208.732 297.597M208.732 297.597L224.691 297.597M208.732 297.597C207.415 294.387 205.999 290.937 204.505 287.302M204.505 287.302L224.75 287.302",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M340.763 317.069L340.723 324.231C340.637 325.276 341.09 327.365 343.591 327.365L413.584 327.365C414.226 327.365 415.997 326.111 417.949 321.098C418.378 319.997 420.391 315.175 423.453 307.893M635.707 221.948L615.623 221.948M498.669 189.943L498.648 193.524L498.69 186.138M498.669 189.943L487.304 189.943M498.669 189.943L510.034 189.943M487.304 189.943L475.939 189.943C473.822 189.943 472.318 192.33 471.83 193.524C461.345 218.249 444.267 258.563 432.132 287.302M487.304 189.943L487.284 193.524L487.326 186.138M510.034 189.943L521.399 189.943C522.843 189.793 526.399 190.301 529.075 193.524L539.467 205.945M510.034 189.943L510.013 193.524L510.055 186.138M539.467 205.945L549.86 218.367C551.056 219.561 553.832 221.948 555.372 221.948L575.455 221.948M539.467 205.945L529.005 205.945L549.93 205.945M595.539 221.948L595.513 226.648M595.539 221.948L575.455 221.948M595.539 221.948L615.623 221.948M575.455 221.948L575.429 226.648M615.623 221.948L615.597 226.648M423.453 307.893L411.771 307.893M423.453 307.893C424.729 304.858 426.187 301.396 427.788 297.597M427.788 297.597L411.829 297.597M427.788 297.597C429.141 294.387 430.597 290.937 432.132 287.302M432.132 287.302L411.888 287.302",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M319.28 202.028L320.286 24.7674C320.29 24.0213 320.78 22.5292 322.704 22.5292L524.987 22.5292C527.231 22.6039 531.724 21.9921 531.742 18.9482C531.759 15.9043 531.805 7.8321 531.825 4.17647C531.75 3.28121 532.177 1.49069 534.486 1.49069L626.437 1.1582",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M318.772 202.028L319.275 113.398L319.778 24.7674C319.782 24.0213 319.311 22.5292 317.389 22.5292L115.414 22.5292C113.172 22.6039 116.784 21.8119 116.802 18.7681C116.819 15.7242 116.865 7.65196 116.885 3.99632C116.971 3.10106 108.473 1.49069 106.167 1.49069L11.9505 1.31055",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M318.529 337.884L318.483 345.941C318.312 347.881 319.027 351.76 323.261 351.76L498.123 351.76C499.405 351.909 502.89 351.044 506.572 346.389L564.226 274.32C565.276 273.052 567.808 270.516 569.539 270.516L635.203 270.516",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M317.527 337.884L317.481 345.941C317.631 347.881 316.871 351.76 312.638 351.76L137.775 351.76C136.492 351.909 133.017 351.044 129.387 346.389L72.5513 274.32C71.5162 273.052 69.0131 270.516 67.2813 270.516L1.61773 270.516",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 97.6548,
    y2: -1,
    transform: "matrix(1 1.14686e-09 -0.00567604 0.999984 538.696 22.7532)",
    stroke: "url(#paint0_linear_416_2897)",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 97.6548,
    y2: -1,
    transform: "matrix(1 1.14686e-09 -0.00567604 0.999984 3.28394 22.7532)",
    stroke: "url(#paint1_linear_416_2897)",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2.00005,
    height: 13.11,
    transform: "matrix(0.999969 0.00597395 0.00222458 -0.999989 294.293 243.799)",
    fill: "url(#paint2_linear_416_2897)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2.00006,
    height: 27.0686,
    transform: "matrix(0.999963 0.00643871 -0.00206399 0.999989 294.253 264.911)",
    fill: "url(#paint3_linear_416_2897)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2.00005,
    height: 22.9425,
    transform: "matrix(0.999969 0.00597395 0.00222458 -0.999989 318.293 243.942)",
    fill: "url(#paint4_linear_416_2897)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2.00006,
    height: 46.9189,
    transform: "matrix(0.999962 0.00657839 -0.00202016 0.999989 318.253 265.068)",
    fill: "url(#paint5_linear_416_2897)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 2.00005,
    height: 13.11,
    transform: "matrix(0.999969 0.00597395 0.00222458 -0.999989 340.293 244.074)",
    fill: "url(#paint6_linear_416_2897)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 2.00006,
    height: 27.0686,
    transform: "matrix(0.999962 0.00657839 -0.00202016 0.999989 340.253 265.213)",
    fill: "url(#paint7_linear_416_2897)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5757 270.5H67.0757C67.909 270.333 70.4757 271.2 74.0757 276L81.0757 285",
    stroke: "url(#paint8_linear_416_2897)",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M600.076 270.5H569.576C568.742 270.333 566.176 271.2 562.576 276L555.576 285",
    stroke: "url(#paint9_linear_416_2897)",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5757 222H75.5",
    stroke: "url(#paint10_linear_416_2897)",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 22.0757,
    y1: 222,
    x2: 22.0757,
    y2: 227,
    stroke: "#D9D9D9"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 42.0757,
    y1: 222,
    x2: 42.0757,
    y2: 227,
    stroke: "#919090"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 62.0757,
    y1: 222,
    x2: 62.0757,
    y2: 227,
    stroke: "#4C4A4A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M616.24 222H555.74C554.574 222 550.44 219.6 543.24 210L528.74 193",
    stroke: "url(#paint11_linear_416_2897)",
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 5,
    y2: -0.5,
    transform: "matrix(5.85695e-10 1 1 0 616.24 222)",
    stroke: "#D9D9D9"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 5,
    y2: -0.5,
    transform: "matrix(5.85695e-10 1 1 0 596.24 222)",
    stroke: "#D9D9D9"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 5,
    y2: -0.5,
    transform: "matrix(5.85695e-10 1 1 0 576.24 222)",
    stroke: "#B0B0B0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M116.566 18.4575C116.583 15.4136 116.629 7.34141 116.65 3.68577C116.735 2.79052 108.237 1.18014 105.932 1.18014L11.7148 1",
    stroke: "url(#paint12_linear_416_2897)",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M531.675 18.4575C531.658 15.4136 531.612 7.34141 531.591 3.68577C531.506 2.79052 540.004 1.18014 542.31 1.18014L636.526 1",
    stroke: "url(#paint13_linear_416_2897)",
    strokeWidth: 2
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 5.99976,
    y1: 201,
    x2: 57.9998,
    y2: 201,
    stroke: "url(#paint14_linear_416_2897)",
    strokeWidth: 2
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 52,
    y2: -1,
    transform: "matrix(-1 0 3.45635e-10 1 632 202)",
    stroke: "url(#paint15_linear_416_2897)",
    strokeWidth: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.03096e-10 -0.00567604 0.999984 620.948 193.076)",
    fill: "#D9D9D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.03096e-10 -0.00567604 0.999984 606.024 193.076)",
    fill: "#D9D9D9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.03096e-10 -0.00567604 0.999984 591.1 193.076)",
    fill: "#D9D9D9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M576.171 193.822C576.173 193.41 576.509 193.076 576.921 193.076L585.248 193.076C586.353 193.076 587.243 193.971 587.237 195.076L587.233 195.707C587.227 196.726 586.396 197.552 585.377 197.552L579.88 197.552C577.82 197.552 576.159 195.882 576.171 193.822Z",
    fill: "#D9D9D9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.03096e-10 -0.00567604 0.999984 17.2412 193.076)",
    fill: "#D9D9D9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.03096e-10 -0.00567604 0.999984 32.1655 193.076)",
    fill: "#D9D9D9"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.03096e-10 -0.00567604 0.999984 47.0898 193.076)",
    fill: "#D9D9D9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0099 193.822C62.0123 193.41 61.6801 193.076 61.2681 193.076L52.9414 193.076C51.8368 193.076 50.9363 193.971 50.9301 195.076L50.9265 195.707C50.9207 196.726 51.7422 197.552 52.7615 197.552L58.2585 197.552C60.3186 197.552 61.9982 195.882 62.0099 193.822Z",
    fill: "#D9D9D9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_416_2897",
    x1: 0,
    y1: 0.5,
    x2: 97.6548,
    y2: 0.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_416_2897",
    x1: 0,
    y1: 0.5,
    x2: 97.6548,
    y2: 0.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_416_2897",
    x1: 1.00002,
    y1: 13.11,
    x2: 1.00002,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_416_2897",
    x1: 1.00003,
    y1: 27.0686,
    x2: 1.00003,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_416_2897",
    x1: 1.00002,
    y1: 22.9425,
    x2: 1.00002,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_416_2897",
    x1: 1.00003,
    y1: 46.9189,
    x2: 1.00003,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_416_2897",
    x1: 1.00002,
    y1: 13.11,
    x2: 1.00002,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_416_2897",
    x1: 1.00003,
    y1: 27.0686,
    x2: 1.00003,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_416_2897",
    x1: 55.0757,
    y1: 279.018,
    x2: 77.2715,
    y2: 276.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_416_2897",
    x1: 581.576,
    y1: 279.018,
    x2: 559.38,
    y2: 276.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_416_2897",
    x1: 21.5,
    y1: 221,
    x2: 74.3084,
    y2: 223.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_416_2897",
    x1: 584.74,
    y1: 233,
    x2: 534.359,
    y2: 204.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_416_2897",
    x1: 122.076,
    y1: 6.5,
    x2: 15.6728,
    y2: -10.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_416_2897",
    x1: 526.166,
    y1: 6.5,
    x2: 632.568,
    y2: -10.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_416_2897",
    x1: 5.99976,
    y1: 202.5,
    x2: 57.9998,
    y2: 202.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_416_2897",
    x1: 0,
    y1: 0.5,
    x2: 52,
    y2: 0.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1Frame15);
export default __webpack_public_path__ + "static/media/card1-frame15.7558304e73327e1501bf3f5cbacd3e11.svg";
export { ForwardRef as ReactComponent };